export default function HoverFace() {
  return (
    <img
      src={process.env.PUBLIC_URL + "/images/46HELLOPRINCESSHover.jpg"}
      alt=""
    />
  );
}
